import $api from "..";
import { IAddColumn } from "../common/api_interfaces/column/IAddColumn";
import { IEditColumn } from "../common/api_interfaces/column/IEditColumn";
import { IMakeColumnProxy } from "../common/api_interfaces/column/IMakeColumnProxy";
import { IMakeColumnCommon } from "../common/api_interfaces/column/IMakeColumnCommon";
import { IMoveColumnData } from "../common/api_interfaces/column/IMoveColumn";
import { IDeleteColumn } from "../common/api_interfaces/column/IDeleteColumn";

export default class ColumnService {

 async addColumn(body: IAddColumn): Promise<void> {
        return $api.post("/column/add", body);
    }

    async editColumn(body: IEditColumn): Promise<void> {
        return $api.post("/column/edit", body);
    }

    async makeColumnProxy(body: IMakeColumnProxy): Promise<void> {
        return $api.post("/column/makeProxy", body);
    }

    async makeColumnCommon(body: IMakeColumnCommon): Promise<void> {
        return $api.post("/column/makeCommon", body);
    }

    async deleteColumn(body: IDeleteColumn): Promise<void> {
        return $api.post("/column/delete", body);
    }

    async moveColumn(body: IMoveColumnData): Promise<void> {
        return $api.post("/column/move", body);
    }
}
